import React from 'react';
import { TextField } from '@iclinic/design-system';

export type RenderTextFieldProps<T extends Record<string, any>> = Readonly<{
  id: string;
  name: keyof T;
  label: string;
  placeholder: string;
  gridArea: string;
  values: T;
  errors: Partial<Record<keyof T, string>>;
  touched: Partial<Record<keyof T, boolean>>;
  handleChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
  extraProps?: Partial<React.ComponentProps<typeof TextField>>;
}>;

export function RenderTextField<T extends Record<string, any>>({
  id,
  name,
  label,
  placeholder,
  gridArea,
  values,
  errors,
  touched,
  handleChange,
  extraProps = {},
}: RenderTextFieldProps<T>) {
  return (
    <TextField
      id={id}
      label={label}
      name={name as string}
      placeholder={placeholder}
      value={values[name] === 'null' ? '' : values[name]}
      onChange={handleChange}
      error={touched[name] && !!errors[name]}
      helperText={touched[name] && errors[name]}
      style={{ gridArea }}
      {...extraProps}
    />
  );
}
